(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersController', HubFlyersController);

    function HubFlyersController(Principal, Constants, $scope, $translate, $localStorage, $state, FlyersService,
                                 FlyerCategoryService, toastr, $timeout, RemoveModalFactory, ModalFactory, paginationConstants,
                                 StoreService, $stateParams, BrandService, ModalBrandFactory, ShowcasesService, StoreTypeService,
                                 ErpsSettingsService, OnlineRetailService, HubService, HubFlyersService, ConfirmPublishModalFactory, BlingService, NexaasService, $uibModal, $window,
                                 $rootScope, systemConstants, flyersConstants, MODAL_CONTENT_TYPES) {

        var vm = this;
        var storeId = $localStorage.defaultStore.storeId;
        var userId = $localStorage.userId;
        var listFilterLocalStorageKey = 'listFilter_' + userId + '_' + storeId;
        var filterLocalStorageKey = 'filter_' + userId + '_' + storeId;
        var isListViewLocalStorageKey = 'isListView_' + userId + '_' + storeId;
        var WITH_STOCK = 'WITH_STOCK';
        var OUT_OF_STOCK = 'OUT_OF_STOCK';
        var STORE_PAGE_DEFAULT = 0;
        var STORE_SIZE_DEFAULT = 9999;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.time_stamp_to_image = '';

        vm.selectedFlyers = [];

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };
        vm.configuration = {};

        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isHubContext = $localStorage.defaultStore.hubContext;

        vm.flyersFiltered = [];
        vm.flyersTypes = [];
        vm.zeroOffers = false;
        vm.startDate = {
            startDate: null,
            endDate: null
        };
        vm.isLoading = true;
        vm.listFlyers = true;
        vm.loadingArray = ["1", "2", "3", "4"];

        vm.isListView = $localStorage[isListViewLocalStorageKey] === undefined ? true : $localStorage[isListViewLocalStorageKey];

        vm.listFilter = $localStorage[listFilterLocalStorageKey] || {
            activated: null,
            hasInventory: false,
            storeId: $localStorage.defaultStore.storeId,
            sortBy: 'lastModifiedDate',
            sortDirection: 'desc',
        };

        vm.hub = $localStorage.defaultStore.hubId;

        vm.listFilter.storeId = $localStorage.defaultStore.storeId;

        vm.filters = $localStorage[filterLocalStorageKey] || {
            region: [],
            categories: [],
            brands: [],
            colors: [],
            sizes: [],
            genders: [],
            bedrooms: [],
            bathrooms: [],
            parkingSpots: [],
            configurations: [],
            hasInventory: true,
            minValue: null,
            maxValue: null,
            minMeters: null,
            maxMeters: null,
            sinceDate: null,
            untilDate: null,
            sortSelected: {
                value: 'lastModifiedDate',
                direction: 'desc',
            },
        };

        vm.userIsAdmin = false;

        vm.flyersToRemove = [];
        vm.page = 0;
        vm.hasNextPage = false;
        vm.busy = false;
        vm.brands = [];
        vm.brandGroups = {};
        vm.colors = [];
        vm.categoryGroups = {};
        vm.numberFilterSelected = 0;


        vm.stores = [];
        vm.storesSelected = [];
        vm.storeTypes = [];
        vm.storeName = '';

        vm.requestParamsStore = {
            page: STORE_PAGE_DEFAULT,
            size: STORE_SIZE_DEFAULT
        }


        vm.selectedSortByOption = "lastModifiedDate";

        vm.flyerMethods = new Map();

        vm.$onInit = init;

        function init() {
            var locale = $translate.use().toLowerCase();

            vm.sortOptions = vm.isImmoContext
                ? paginationConstants.immoSortOptions[locale].filter(function (option) {
                    return option.value !== 'metadata.published';
                })
                : paginationConstants.hubSortOptions[locale];

            loadStore();
            configureFlyerMethods();
            initializeActionsOptions();
            initializeMassSelectionActionsOptions();
            getConfigurationsValues();

            vm.listFilter.sortBy = 'lastModifiedDate';
            vm.listFilter.sortDirection = 'desc';
            loadAll();
        }

        function updateListView() {
            if ($window.innerWidth <= 768) {
                vm.isListView = true
                $localStorage[isListViewLocalStorageKey] = vm.isListView;
            }
        }

        updateListView();

        angular.element($window).on('resize', function () {
            $scope.$apply(updateListView);
        });

        function loadStores(pageOptions) {
            vm.isStoresAvailable = false;

            StoreService.listStoresByCurrentHub({}, pageOptions, function (data, headers) {
                vm.stores = data;
                vm.isStoresAvailable = true;
            }, function (error) {
                vm.isStoresAvailable = true;
            });
        }


        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        vm.loadingActionRequest = false;
        vm.erpProductsCount = 0;

        function initializeActionsOptions() {
            vm.selectedActions = [
                {
                    value: 'REMOVE',
                    translation: vm.getTranslateKey('flyers.selection-actions.remove'),
                    actionFunc: function () {
                        return vm.verifyIfFlyersIsPublished();
                    }
                }
            ];

            vm.moreActions = [
                {
                    name: 'importFlyer',
                    icon: "fa fa-cloud-upload",
                    label: vm.getTranslateKey('flyers.import.subtitle'),
                    method: vm.goToImport
                }
            ];

            vm.flyerActionsCache = {};

            vm.flyerActions = [
                {
                    name: flyersConstants.FLYER_ACTION.EDIT,
                    icon: "icon-ksc-pen-to-square-light",
                    label: 'flyers.actions.edit',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.EDIT)
                },
                {
                    name: flyersConstants.FLYER_ACTION.DELETE,
                    icon: "icon-ksc-trash-light",
                    label: 'flyers.actions.delete',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.DELETE)
                },
                {
                    name: flyersConstants.FLYER_ACTION.DUPLICATE,
                    icon: "icon-ksc-clone-light",
                    label: 'flyers.actions.duplicate',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.DUPLICATE),
                    hidden: function () {
                        return true;
                    }
                },
                {
                    name: flyersConstants.FLYER_ACTION.RECOMMEND,
                    icon: "fa fa-star",
                    label: 'flyers.actions.recommend',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.RECOMMEND),
                    hidden: function () {
                        return true;
                    }
                },
                {
                    name: flyersConstants.FLYER_ACTION.UNPUBLISH,
                    icon: "icon-ksc-arrow-down-light",
                    label: 'flyers.actions.unpublishFlyer',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.UNPUBLISH),
                    hidden: function (flyer) {
                        return true;
                    }
                },
                {
                    name: flyersConstants.FLYER_ACTION.PUBLISH,
                    icon: "icon-ksc-arrow-up-light",
                    label: 'flyers.actions.publishFlyer',
                    method: vm.flyerMethods.get(flyersConstants.FLYER_ACTION.PUBLISH),
                    hidden: function (flyer) {
                        return true;
                    }
                }
            ];


            if (!vm.isImmoContext) {
                vm.selectedActions.push(
                    {
                        value: 'CLEAR_STOCK',
                        translation: 'flyers.selection-actions.clear-stock',
                        actionFunc: function () {
                            ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.clear-stock-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.clear-stock-modal.subtitle', {amount: vm.selectedFlyers.length}),
                                $translate.instant('flyers.selection-actions.modals.clear-stock-modal.small-text'),
                                null,
                                $translate.instant('flyers.selection-actions.modals.clear-stock-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                vm.clearStock
                            );
                        }
                    },
                    {
                        value: 'APPLY_DISCOUNTS',
                        translation: 'flyers.selection-actions.apply-discounts',
                        actionFunc: function () {
                            ModalFactory.openDiscountModal($translate.instant('flyers.selection-actions.modals.discount-modal.title'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.subtitle'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.input-label'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.input-footer'),
                                $translate.instant('flyers.selection-actions.modals.discount-modal.confirm-button'),
                                $translate.instant('flyers.selection-actions.modals.cancel'),
                                applyDiscounts
                            );
                        }
                    }
                );
            }

            vm.selectedActions.push();
        }

        function initializeMassSelectionActionsOptions() {
            vm.selectionTypes = [
                {
                    value: 'ALL_FROM_PAGE',
                    translation: 'flyers.selection-filters.select-all-from-page'
                },
                {
                    value: 'OUT_OF_STOCK',
                    translation: 'flyers.selection-filters.out-of-stock'
                },
                {
                    value: 'WITH_STOCK',
                    translation: 'flyers.selection-filters.with-stock'
                },
                {
                    value: 'NONE',
                    translation: 'flyers.selection-filters.select-none'
                }
            ];
        }

        vm.getSelectionTypes = function () {
            if (vm.isImmoContext) {
                return vm.selectionTypes.filter(function (type) {
                    return type.value !== WITH_STOCK && type.value !== OUT_OF_STOCK;
                });
            }
            return vm.selectionTypes;
        };

        vm.selectionTypesData = {
            currentSelection: 'NONE',
            'ALL': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllFromStore();
                }
            },
            'ALL_FROM_PAGE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllItems();
                }
            },
            'OUT_OF_STOCK': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllOutOfStock();
                }
            },
            'WITH_STOCK': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllWithStock();
                }
            },
            'NONE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.unselectAll();
                }
            }
        };

        vm.onSelectedSortOption = function (newValue) {
            clearPaginationInfo();
            vm.selectedSortByOption = newValue;
            vm.listFilter.sortBy = vm.selectedSortByOption.value;
            vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
            loadFlyers();
        }

        checkUserIsAdmin();

        vm.loadFlyers = loadFlyers;

        vm.randomTime = new Date().getTime();

        function clearPaginationInfo() {
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        function checkUserIsAdmin() {
            Principal.hasAuthority("ADMIN_MANAGE_SYSTEM").then(function (result) {
                if (result) {
                    vm.userIsAdmin = true;
                } else {
                    vm.userIsAdmin = false;
                }
            });
        }

        vm.searchForTerm = function () {
            clearPaginationInfo();
            vm.loadFlyers();
        }

        vm.changeDisplayType = function () {
            vm.isListView = !vm.isListView;
            $localStorage[isListViewLocalStorageKey] = vm.isListView;
        };

        vm.flyerDetailPage = function (flyerId) {
            $state.go('hub-flyers.edit', {
                id: flyerId
            });
        };

        vm.goToImport = function () {
            $state.go('flyers.import');
        };

        vm.buildFlyerActions = function (flyer) {
            if (vm.flyerActionsCache[flyer.id]) {
                return vm.flyerActionsCache[flyer.id];
            }

            var actionNames = ['EDIT', 'DELETE', 'DUPLICATE', 'RECOMMEND', 'UNPUBLISH', 'PUBLISH'];

            var actions = actionNames.map(function (name) {
                var baseAction = vm.flyerActions.find(function (a) {
                    return a.name === name;
                });

                if (!baseAction) return null;

                return {
                    name: baseAction.name,
                    label: baseAction.label,
                    shortLabel: baseAction.shortLabel,
                    icon: baseAction.icon,
                    hidden: typeof baseAction.hidden === 'function' ? function () {
                        return baseAction.hidden(flyer);
                    } : baseAction.hidden,
                    method: typeof baseAction.method === 'function' ? function () {
                        return baseAction.method(flyer);
                    } : baseAction.method
                };
            }).filter(function (item) {
                return item !== null;
            });

            vm.flyerActionsCache[flyer.id] = actions;
            return actions;
        };

        vm.flyerDetailModal = function (flyerId) {
            var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                return flyer.id === flyerId;
            });
            var flyerActions = vm.buildFlyerActions(flyerSelected);

            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/flyers/flyer-detail/flyer-detail-modal.html',
                controller: 'FlyerDetailsController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal',
                windowTopClass: 'flyer-detail-modal full-bleed',
                size: 'double-panel',
                backdrop: 'static',
                resolve: {
                    flyerId: function () {
                        return flyerId;
                    },
                    isHubContext: function () {
                        return vm.isHubContext;
                    },
                    isImmoContext: function () {
                        return vm.isImmoContext;
                    },
                    menuActions: function () {
                        var modalActionsNames = ['EDIT', 'DELETE', 'DUPLICATE', 'RECOMMEND', 'PUBLISH', 'UNPUBLISH'];
                        var modalActions = [];
                        modalActionsNames.forEach(function (modalActionName) {
                            var modalAction = flyerActions.find(function (action) {
                                return action.name === modalActionName;
                            });
                            modalActions.push(modalAction);
                        });
                        return modalActions;
                    },
                    quickActions: function () {
                        return [];
                    }
                }
            });

            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.CLOSE_DETAILS_MODAL,
                function (actionName) {
                    modalInstance.dismiss(actionName);
                }
            );

            return modalInstance;
        }

        vm.verifyIfFlyersIsPublished = function () {
            var closeModal = vm.flyerMethods.get(flyersConstants.FLYER_ACTION.CLOSE_DETAILS_MODAL);
            if (typeof closeModal === 'function') {
                closeModal(flyersConstants.FLYER_ACTION.EDIT);
            }

            if(vm.singleFlyerToDelete) {
                FlyersService.verifyIfFlyersIsPublished([vm.flyerToDelete]).then(function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.remove-modal.title'),
                        $translate.instant(vm.getTranslateKey('flyers.selection-actions.modals.remove-modal.subtitle-single-removal')),
                        $translate.instant('flyers.selection-actions.modals.remove-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.remove-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.removeFlyers
                    );
                });
            }
            else {
                FlyersService.verifyIfFlyersIsPublished(vm.selectedFlyers).then(function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.remove-modal.title'),
                        $translate.instant(vm.getTranslateKey('flyers.selection-actions.modals.remove-modal.subtitle'), {amount: vm.selectedFlyers.length}),
                        $translate.instant('flyers.selection-actions.modals.remove-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.remove-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.removeFlyers
                    );
                });
            }
        }

        vm.removeFlyers = function () {
            if(vm.singleFlyerToDelete) {
                vm.removalLoading = true;
                vm.loadingActionRequest = true;
                FlyersService.deleteHubFlyers([vm.singleFlyerToDelete]).then(function (data) {
                    toastr.success($translate.instant('flyers.messages.remove.success'));
                    vm.selectedFlyers = [];
                    $state.reload();
                }, function () {
                    toastr.error($translate.instant('flyers.messages.remove.error'));
                });
                vm.singleFlyerToDelete = null;
            } else {
                if (vm.existsSelectedItems()) {
                    vm.removalLoading = true;
                    vm.loadingActionRequest = true;
                    FlyersService.deleteHubFlyers(vm.selectedFlyers).then(function (data) {
                        toastr.success($translate.instant('flyers.messages.remove.success'));
                        vm.selectedFlyers = [];
                        $state.reload();
                    }, function (data) {
                        toastr.error($translate.instant('flyers.messages.remove.error'));
                    });
                } else {
                    toastr.error($translate.instant('flyers.messages.remove.noItens'));
                }
            }
        };

        function resetSelectionState() {
            vm.selectionState.all = true;
            vm.selectionState.storeTypeId = '';
            vm.selectionState.selectedStoreIds = [];
            vm.selectionState.excludedStoreIds = [];
        }

        vm.migrateFlyers = function () {
            vm.isAvailable = true;

            if (vm.selectedFlyers.length > 0) {
                var cleanOptions = function () {
                    vm.isAvailable = false;
                    vm.storesSelected = [];
                }

                var state = vm.selectionState || {};

                var hasFlyers = vm.selectedFlyers && vm.selectedFlyers.length > 0;

                var isRestEmpty =
                    (!state.all || state.all === false) &&
                    (!state.storeTypeId) &&
                    (!state.excludedStoreIds || state.excludedStoreIds.length === 0) &&
                    (!state.selectedStoreIds || state.selectedStoreIds.length === 0) &&
                    (!state.flyerIds || state.flyerIds.length > 0)

                if (hasFlyers && isRestEmpty) {
                    ConfirmPublishModalFactory.publishItem().then(function (data) {
                        if (data) {
                            resetSelectionState();

                            HubService.migrateFlyersToStoreSelection(vm.selectionState).then(function (){
                                toastr.success($translate.instant('flyers.messages.global.distribution-started'));
                                cleanOptions();
                            } ) ;
                        }
                    }, function (err) {
                        vm.isAvailable = false;
                    });
                } else {
                    HubService.migrateFlyersToStoreSelection(vm.selectionState).then(function (){
                        toastr.success($translate.instant('flyers.messages.global.distribution-started'));
                        cleanOptions();
                    } ) ;
                }
            }
        };

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function (el) {
                return el.key === flyer.categoryKey
            });
            if (category) {
                flyer.category = category.title;
            }
        }

        function loadAll() {
            vm.time_stamp_to_image = '?' + Date.now();
            loadErpConfiguration();
            loadBrandsAndCategories();
            getFlyersTypes();

            ShowcasesService.getAllFlyerIdsFromShowcasesPublished().then(function (data) {
                vm.publishedProducts = data;
            });

            if ($stateParams.type) {
                // Changes the type to the new type Clicked
                vm.listFilter.type = $stateParams.type;

                // Erases the offer list
                vm.flyersFiltered = [];

                // Turn to 0 the page to give right page on pageable
                vm.page = 0;
            }

            FlyersService.getAllFiltersHubFlyers(vm.hub).then(function (response) {
                vm.colors = response.data.colors;
                vm.sizes = response.data.sizes;
            });

            loadFlyers();
        }

        function getCategories() {
            if (!vm.categories || !vm.categories.length) {
                FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function (response) {
                    vm.categories = response.data;
                    vm.categories = _.uniqBy(vm.categories, 'key');
                    vm.categories.forEach(function (category) {
                        vm.categoryGroups[category.key] = {
                            count: 0,
                            total: category.countFlyer
                        };
                    });
                    sortCategoriesByName();
                });
            }
        }

        function getFlyersTypes() {
            FlyersService.getFlyerTypes().then(function (response) {
                var removeRent = response.data.map(function (item) {
                    return item.code;
                }).indexOf('RENT');
                response.data.splice(removeRent, 1);
                var removeContact = response.data.map(function (item) {
                    return item.code;
                }).indexOf('CONTACT');
                response.data.splice(removeContact, 1);
                vm.flyersTypes = response.data;
            });
        }

        function loadErpConfiguration() {
            ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                .then(function (response) {
                    if (response.data && response.data.id) {
                        vm.configuration = response.data;
                    }
                });
        }

        function loadBrandsAndCategories() {
            setTimeout(function () {
                //load default filter
                getCategories();
                loadBrands();
            }, 1000);
        }

        function sortCategoriesByName() {
            vm.categories = vm.categories.sort(function (a, b) {
                if (a.title.toLowerCase() < b.title.toLowerCase()) {
                    return -1;
                }
                if (a.title.toLowerCase() > b.title.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        vm.refreshSelectedFlyers = function (flyer) {
            vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] ? vm.brandGroups[flyer.brand] : {count: 0};
            vm.categoryGroups[flyer.categoryKey] = vm.categoryGroups[flyer.categoryKey] ? vm.categoryGroups[flyer.categoryKey] : {count: 0};
            if (vm.selectedFlyers.indexOf(flyer.id) != '-1') {
                vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count - 1;
                vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count - 1;
                flyer.isSelected = false;
                vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
            } else {
                vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count + 1;
                vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count + 1;
                flyer.isSelected = true;
                vm.selectedFlyers.push(flyer.id);
            }
            vm.selectedAll = true;
            angular.forEach(vm.flyersFiltered, function (flyer) {
                if (vm.selectedFlyers.indexOf(flyer.id) === -1) {
                    vm.selectedAll = false;
                    flyer.isSelected = false;
                }
            });

            if (!vm.selectionState) {
                vm.selectionState = {
                    flyerIds: vm.selectedFlyers
                };
            } else {
                vm.selectionState.flyerIds = vm.selectedFlyers;
            }
        };

        vm.existsSelectedItems = function () {
            return vm.selectedFlyers.length >= 1;
        };

        vm.isIndeterminate = function () {
            var filteredSelected = vm.flyersFiltered.filter(function (flyer) {
                return flyer.isSelected
            });
            return vm.selectedFlyers.length > 0
                && filteredSelected.length >= 1
                && filteredSelected.length !== vm.flyersFiltered.length;
        }

        vm.isAllFromPageSelected = function () {
            return vm.selectedFlyers.length > 0 && vm.flyersFiltered.every(function (flyer) {
                return flyer.isSelected
            });
        }

        vm.getCountSelectedByBrand = function (brand) {
            return vm.brandGroups[brand].count;
        };

        vm.getCountSelectedByCategory = function (category) {
            return vm.categoryGroups[category].count;
        };

        vm.refreshFlyersSelected = function () {
            vm.makeBrandGroups();
        }

        vm.selectAllItems = function () {
            vm.selectedAll = !vm.isAllFromPageSelected();
            angular.forEach(vm.flyersFiltered, function (flyer) {
                if (vm.selectedAll) {
                    if (vm.selectedFlyers.indexOf(flyer.id) === -1) {
                        if (!vm.brandGroups[flyer.brand]) {
                            vm.brandGroups[flyer.brand] = {count: 0}
                        }

                        if (!vm.categoryGroups[flyer.categoryKey]) {
                            vm.categoryGroups[flyer.categoryKey] = {count: 0}
                        }
                        vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count + 1;
                        vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count + 1;
                        flyer.isSelected = true;
                        vm.selectedFlyers.push(flyer.id);
                    }
                } else {
                    if (vm.selectedFlyers.indexOf(flyer.id) !== -1) {
                        vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count - 1;
                        vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count - 1;
                        flyer.isSelected = false;
                        vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
                    }
                }
            });
        };

        vm.checkIfFlyerSelected = function (flyer) {
            return vm.selectedFlyers.indexOf(flyer.id) != '-1';
        }

        vm.selectItemsBy = function (selectBy, isFromSelection) {
            isFromSelection = isFromSelection ? isFromSelection : false;
            if (selectBy === 'ALL_FROM_PAGE' && vm.isAllFromPageSelected() && !vm.isIndeterminate() && !isFromSelection) {
                vm.unselectAllFromPage();
                vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;
                vm.selectionTypesData.currentSelection = 'NONE'
                return;
            }

            if (isFromSelection && selectBy !== 'ALL_FROM_PAGE') {
                vm.unselectAll();
            }
            vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;

            vm.selectionTypesData[selectBy].selectFunc();

            vm.selectionTypesData.currentSelection = selectBy;
            vm.selectionTypesData[selectBy].isActivated = true;
        }

        vm.isErpIntegrated = function (flyer) {
            if (flyer.erpProductId) {
                return true;
            } else if (flyer.details && flyer.details.length) {
                for (var index in flyer.details) {
                    var detail = flyer.details[index];
                    if (detail.erpProductId) {
                        return true;
                    }
                }
            } else {
                return false;
            }
        }

        vm.showAction = function (action) {
            if (action.value === 'SYNC_ERP') {
                return vm.configuration && vm.configuration.id && vm.configuration.id != Constants.ErpPartnerId.SETA;
            }
            return true;
        }

        function setSelectedProductsByBrand(brandSet) {
            vm.brands.forEach(function (brand) {
                if (brandSet[brand.name]) {
                    var flyersId = brandSet[brand.name].map(function (product) {
                        var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                            return flyer.id === product.id;
                        });
                        if (flyerSelected) flyerSelected.isSelected = true;
                        return product.id;
                    })
                    vm.selectedFlyers = vm.selectedFlyers.concat(flyersId);
                    vm.brandGroups[brand.name].count = brandSet[brand.name].length;
                }
            });
            vm.selectedFlyers = _.uniq(vm.selectedFlyers);
        }

        function setSelectedProductsByCategory(categorySet) {
            if (vm.isImmoContext) {
                var flyersId = Object.values(categorySet).flat().map(function (product) {
                    var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                        return flyer.id === product.id;
                    });
                    if (flyerSelected) flyerSelected.isSelected = true;
                    return product.id;
                });
                vm.selectedFlyers = _.uniq(vm.selectedFlyers.concat(flyersId));
            } else {
                vm.categories.forEach(function (category) {
                    if (categorySet[category.key]) {
                        var flyersId = categorySet[category.key].map(function (product) {
                            var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                                return flyer.id === product.id;
                            });
                            if (flyerSelected) flyerSelected.isSelected = true;
                            return product.id;
                        });

                        vm.selectedFlyers = vm.selectedFlyers.concat(flyersId);
                        vm.categoryGroups[category.key].count = categorySet[category.key].length;
                    }
                });
                vm.selectedFlyers = _.uniq(vm.selectedFlyers);
            }
        }

        vm.selectAllFromStore = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllWithStock = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                hasInventory: true
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllOutOfStock = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                hasNoInventory: true,
                brandSelected: !!vm.listFilter.brand
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.unselectAll = function () {
            vm.selectedFlyers = [];
            vm.brands.forEach(function (brand) {
                vm.brandGroups[brand.name].count = 0;
            });
            vm.categories.forEach(function (category) {
                vm.categoryGroups[category.key].count = 0;
            });
            vm.loadingSelection = false;
        }

        vm.unselectAllFromPage = function () {
            vm.flyersFiltered.forEach(function (flyer) {
                if (vm.selectedFlyers.indexOf(flyer.id) !== -1) {
                    vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count - 1;
                    vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count - 1;
                    flyer.isSelected = false;
                    vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
                }
            });
            vm.loadingSelection = false;
        }


        vm.clearStock = function () {
            vm.loadingActionRequest = true;
            FlyersService.clearHubFlyersStock(vm.selectedFlyers).then(function () {
                vm.selectedFlyers.forEach(function (flyerId) {
                    clearFlyerStock(flyerId);
                });
                vm.unselectAll();
                vm.loadingActionRequest = false;
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.clearStock.error"));
            });
        }

        vm.checkStoreIsSelected = function (id) {
            return vm.storesSelected.includes(id);
        }

        vm.changeStoreSelected = function (payload) {
            var data = payload || { all: false, selectedStoreTypes: [], excludedIds: [], selectedIds: [] };

            if (!vm.selectionState) {
                vm.selectionState = {
                    all: payload.all,
                    storeTypeId: payload.selectedStoreTypeId,
                    excludedStoreIds: payload.excludedIds,
                    selectedStoreIds: payload.selectedIds,
                    flyerIds: []
                };
            } else {
                vm.selectionState.all = payload.all;
                vm.selectionState.storeTypeId = payload.selectedStoreTypeId;
                vm.selectionState.excludedStoreIds = payload.excludedIds;
                vm.selectionState.selectedStoreIds = payload.selectedIds;
                vm.selectionState.flyerIds = vm.selectedFlyers;
            }

            if (!data.all && !data.selectedStoreTypeId) {
                vm.storesSelected = data.selectedIds;
            } else {
                vm.storesSelected = data.selectedIds;
            }
        };

        function applyDiscounts(discountApplied) {
            vm.loadingActionRequest = true;
            FlyersService.applyDiscountsForHubFlyers(vm.selectedFlyers, discountApplied).then(function () {
                loadFlyers();
                vm.unselectAll();
                vm.loadingActionRequest = false;
            }, function () {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.applyDiscounts.error"));
            });
        }

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;

            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalFlyers);
        }

        vm.onChangeItemsPerPage = function (newValue) {
            if (vm.numPerPage === newValue ) {
                return
            }
            clearPaginationInfo();
            vm.numPerPage = newValue;
            vm.onChangePage();
        };

        vm.onChangePage = function () {
            vm.changePage();
            loadFlyers();
        };

        vm.loadFilter = function (filterType, listKey, singleKey, valueKey) {
            if (vm.filters[filterType].length > 0) {
                var formatedList = vm.filters[filterType].map(function (item) {
                    return item[valueKey];
                });

                vm.listFilter[listKey] = formatedList;

                if (singleKey && formatedList.length > 0) {
                    vm.listFilter[singleKey] = formatedList[0];
                }
            } else {
                delete vm.listFilter[listKey];
                if (singleKey) {
                    delete vm.listFilter[singleKey];
                }
            }
            clearPaginationInfo();
            loadFlyers();
        };

        vm.loadFilterRange = function () {
            if (vm.filters.minValue && vm.filters.maxValue) {
                vm.listFilter.minValue = vm.filters.minValue;
                vm.listFilter.maxValue = vm.filters.maxValue;
            } else {
                delete vm.listFilter.minValue;
                delete vm.listFilter.maxValue;
            }
            clearPaginationInfo();
            loadFlyers();
        }

        function getFiltersNumber() {
            vm.numberFilterSelected = vm.filters.categories.length + vm.filters.brands.length + vm.filters.region.length +
                vm.filters.colors.length + vm.filters.sizes.length + vm.filters.genders.length +
                (vm.filters.imageOptions ? 1 : 0) +
                vm.filters.configurations.length + (Array.isArray(vm.filters.bedrooms) ? vm.filters.bedrooms.length : 0) +
                (Array.isArray(vm.filters.parkingSpots) ? vm.filters.parkingSpots.length : 0) +
                (Array.isArray(vm.filters.bathrooms) ? vm.filters.bathrooms.length : 0) +
                (vm.filters.minValue && vm.filters.maxValue ? 1 : 0) +
                (vm.filters.minMeters && vm.filters.maxMeters ? 1 : 0) +
                (vm.filters.sinceDate && vm.filters.untilDate ? 1 : 0);
        }

        function loadFlyers() {
            if (vm.busy) return;
            vm.busy = true;

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("launch")) {
                vm.listFilter.launch = true;
            } else {
                delete vm.listFilter.launch;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("basic")) {
                vm.listFilter.basic = true;
            } else {
                delete vm.listFilter.basic;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("delivered")) {
                vm.listFilter.delivered = true;
            } else {
                delete vm.listFilter.delivered;
            }

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (!vm.listFilter.sizes || !(vm.listFilter.sizes.length > 0)) {
                delete vm.listFilter.sizes
            }

            if (!vm.listFilter.bedrooms || !(vm.listFilter.bedrooms.length > 0)) {
                delete vm.listFilter.bedrooms
            }

            if (!vm.listFilter.bathrooms || !(vm.listFilter.bathrooms.length > 0)) {
                delete vm.listFilter.bathrooms
            }

            if (!vm.listFilter.parkingSpots || !(vm.listFilter.parkingSpots.length > 0)) {
                delete vm.listFilter.parkingSpots
            }

            if (!vm.listFilter.genders || !(vm.listFilter.genders.length > 0)) {
                delete vm.listFilter.genders
            }

            if (!vm.listFilter.minValue || vm.listFilter.minValue === '') {
                delete vm.listFilter.minValue
            }

            if (!vm.listFilter.maxValue || vm.listFilter.maxValue === '') {
                delete vm.listFilter.maxValue
            }

            if (!vm.listFilter.minMeters || vm.listFilter.minMeters === '') {
                delete vm.listFilter.minMeters
            }

            if (!vm.listFilter.maxMeters || vm.listFilter.maxMeters === '') {
                delete vm.listFilter.maxMeters
            }

            if (!vm.listFilter.sinceDate) {
                delete vm.listFilter.sinceDate
            }

            if (!vm.listFilter.untilDate) {
                delete vm.listFilter.untilDate
            }

            if (!vm.listFilter.region || !(vm.listFilter.region.length > 0)) {
                delete vm.listFilter.region
            }

            if (!vm.filters.categories || !(vm.filters.categories.length > 0)) {
                delete vm.listFilter.categoryKeys;
                delete vm.listFilter.categoryKey;
            }

            if (!vm.filters.brands || !(vm.filters.brands.length > 0)) {
                delete vm.listFilter.brand;
                delete vm.listFilter.brands;
            }

            if (vm.selectedSortByOption.value === 'inventory') {
                vm.listFilter.hasInventory = false;
            }

            getEmptyMessage()

            getFiltersNumber()

            HubFlyersService.listFlyers(vm.paginationOptions, vm.listFilter, onSuccess, onError);

            function onSuccess(data, headers) {

                vm.zeroOffers = data.length <= 0;
                vm.flyersFiltered = data;

                if (vm.zeroOffers) {
                    vm.flyersFiltered = [];
                    vm.selectedAll = false;
                } else {
                    vm.selectedAll = true;
                    angular.forEach(vm.flyersFiltered, function (flyer) {
                        var isSelected = vm.selectedFlyers.indexOf(flyer.id);
                        flyer.isSelected = isSelected > -1;
                        if (isSelected === -1) {
                            vm.selectedAll = false;
                        }
                    })
                }

                var storeCurrency = loadCurrencyPrefix(vm.store);
                vm.flyersFiltered = vm.flyersFiltered.map(function (flyer) {
                    vm.getCategoryName(flyer);
                    flyer.currencyInstance = storeCurrency;
                    return flyer;
                });

                vm.totalFlyers = headers('X-Total-Count');
                vm.changePage();

                vm.isLoading = false;
                vm.busy = false;

                var listFilterCopy = angular.copy(vm.listFilter)

                delete listFilterCopy.storeId
                delete listFilterCopy.text

                $localStorage[listFilterLocalStorageKey] = listFilterCopy;
                $localStorage[filterLocalStorageKey] = vm.filters;
            }

            function onError(_) {
                vm.busy = false;
                vm.isLoading = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        function getEmptyMessage() {
            if (vm.listFilter.text && vm.listFilter.text.length > 0) {
                vm.emptyTitle = vm.getTranslateKey('flyers.new.error.notFound');
                vm.emptyDescription = "";
            } else {
                vm.emptyTitle = vm.getTranslateKey('flyers.home.empty.title');
                vm.emptyDescription = vm.getTranslateKey('flyers.home.empty.description');
            }
        }


        function checkForCurrentBrand(brands) {
            var result = false;
            brands.forEach(function (brand) {
                if (brand.name == vm.listFilter.brand)
                    result = true;
            });
            return result;
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(
                function (response) {
                    if (response && response.data) {
                        vm.store = response.data;
                    }
                }
            );
        }

        function loadCurrencyPrefix(store) {
            var storeCurrency = store.currency ? store.currency : "REAL";
            return getCurrencyListConfiguration()[storeCurrency];
        }

        function sortBrandsByName(){
            vm.brands = vm.brands.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase()) {
                    return -1;
                }
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        function loadBrands() {
            BrandService.getBrandsByCurrentStore().then(function (response) {
                vm.brands = response.data;
                if (!checkForCurrentBrand(response.data))
                    vm.listFilter.brand = response.data[0].name;
                vm.brands = _.uniqBy(vm.brands, 'name');
                sortBrandsByName();
                vm.brands.forEach(function (brand) {
                    vm.brandGroups[brand.name] = {
                        count: 0,
                        total: brand.quantFlyer
                    };
                });
            });
        }

        function clearFlyerStock(flyerId) {
            var flyer = vm.flyersFiltered.find(function (filterdFlyer) {
                return flyerId === filterdFlyer.id;
            });
            if (flyer) {
                if (flyer.details && flyer.details.length) {
                    flyer.details.forEach(function (detail) {
                        detail.inventory = 0;
                    })
                } else {
                    flyer.inventory = 0;
                }
            }
        }

        function getConfigurationsValues() {
            vm.configurations = [
                {id: 1, label: "flyers.new.form.configurations.launch", code: "launch"},
                {id: 2, label: vm.getTranslateKey('flyers.new.form.configurations.basic'), code: "basic"}
            ];

            if (vm.isImmoContext) {
                vm.configurations.push(
                    {id: 3, label: "flyers.new.form.configurations.delivered", code: "delivered"}
                );
            }
        }

        vm.bedrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.parkingSpots = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.bathrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.openFiltersModal = function () {
            var filtersConversationModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                categories: vm.categories,
                                brands: vm.brands,
                                colors: vm.colors,
                                sizes: vm.sizes,
                                bedrooms: vm.bedrooms,
                                bathrooms: vm.bathrooms,
                                parkingSpots: vm.parkingSpots,
                                configurations: vm.configurations,
                                clearFilters: vm.clearFilters,
                                itemsPerPageOptions: vm.itemsPerPageOptions,
                                sortOptions: vm.sortOptions,
                                numPerPage: vm.numPerPage,
                                selectedSort: vm.selectedSortByOption
                            },
                            filters: vm.filters,
                            list: vm.listFilter,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.FILTERS
                        }
                    }
                },
            })

            var unbindRouteChange = $rootScope.$on('$locationChangeStart', function() {
                filtersConversationModal.dismiss('route change');
            });

            filtersConversationModal.result.then(function (response) {
                vm.unselectAll();
                if (response) {
                    vm.filters = response.selectedFilters;
                    if (vm.numberFilterSelected === 0) {
                        loadBrandsAndCategories();
                    } else
                        vm.listFilter = response.listFilter;

                    if (response.numPerPage && response.numPerPage !== vm.numPerPage) {
                        vm.numPerPage = response.numPerPage;
                    }
                    clearPaginationInfo();
                    if (response.sortSelected && response.sortSelected !== vm.selectedSortByOption) {
                        vm.selectedSortByOption = response.sortSelected;
                        vm.listFilter.sortBy = vm.selectedSortByOption.value;
                        vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
                    }

                    loadFlyers();
                }
                unbindRouteChange();
            }, function () {
                unbindRouteChange();
            });
        }

        vm.clearFilters = function () {
            vm.unselectAll();

            // Limpa os filtros do vm.filters
            vm.filters = {
                region: [],
                categories: [],
                brands: [],
                colors: [],
                sizes: [],
                genders: [],
                bedrooms: [],
                bathrooms: [],
                parkingSpots: [],
                configurations: [],
                hasInventory: false,
                minValue: null,
                maxValue: null,
                minMeters: null,
                maxMeters: null,
                sinceDate: null,
                untilDate: null,
                tags: [],
                sortSelected: {
                    value: 'lastModifiedDate',
                    direction: 'desc',
                },
            };

            // Reseta o vm.listFilter para o estado inicial
            vm.listFilter = {
                activated: null,
                hasInventory: false,
                storeId: $localStorage.defaultStore.storeId,
                sortBy: 'lastModifiedDate',
                sortDirection: 'desc',
            };

            delete vm.listFilter.sinceDate;
            delete vm.listFilter.untilDate;

            // Atualiza o localStorage
            $localStorage[listFilterLocalStorageKey] = angular.copy(
                vm.listFilter
            );
            $localStorage[filterLocalStorageKey] = angular.copy(vm.filters);

            clearPaginationInfo();
            loadFlyers();
        };

        function accessHotsite(flyer) {
            window.open(flyer.flyerUrl, '_blank');
        }

        function copyLink(flyer) {
            var url = flyer.flyerUrl;
            var input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand('copy');
            document.body.removeChild(input);


            navigator.clipboard.writeText(url).then(function () {
                toastr.success($translate.instant('flyers.card.messages.link'));
            });
        }

        function shareWhatsapp(flyer) {
            var url = flyer.flyerUrl;
            var message = $translate.instant('flyers.card.messages.whatsapp-product') + ' ' + url;
            var whatsappUrl = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);
            window.open(whatsappUrl, '_blank');
        }

        vm.withoutStockTooltip = function (item) {
            return item.inventory <= 0 && item.inventory != null ? $translate.instant('flyers.offerList.without-stock') : ''
        }

        vm.unlimitedStock = function (item) {
            return item.inventory != null ? item.inventory : $translate.instant('flyers.offerList.unlimited-stock');
        }

        function configureFlyerMethods() {
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.HOTSITE,
                function (flyer) {
                    accessHotsite(flyer);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.LINK, function (flyer) {
                    copyLink(flyer);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.SEND,
                function (flyer) {
                    shareWhatsapp(flyer);
                });
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.EDIT,
                function (flyer) {
                    $state.go('hub-flyers.edit', {
                        id: flyer.id
                    });
                    var closeModal = vm.flyerMethods.get(flyersConstants.FLYER_ACTION.CLOSE_DETAILS_MODAL);
                    if (typeof closeModal === 'function') {
                        closeModal(flyersConstants.FLYER_ACTION.EDIT);
                    }
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.DELETE,
                function (flyer) {
                    vm.singleFlyerToDelete = flyer.id
                    vm.verifyIfFlyersIsPublished();
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.DUPLICATE,
                function (flyer) {
                    // TODO: implementar duplicação
                    console.log(flyersConstants.FLYER_ACTION.DUPLICATE + ': ' + flyer.id);
                }
            );
            vm.flyerMethods.set(
                flyersConstants.FLYER_ACTION.RECOMMEND,
                function (flyer) {
                    // TODO: implementar ou remover recomendação
                    console.log(flyersConstants.FLYER_ACTION.RECOMMEND + ': ' + flyer.id);
                }
            );
        }
    }
})();
